export default __webpack_public_path__ + "static/media/mode-35.72e78425.svg";